// Service page content for Visitor visa (Subclass 600).
// Sourced from docs/research/australian-visa-pathways.md §8.
// COMPLIANCE: we prepare and coordinate; a registered migration agent advises,
// confirms the stream, and lodges. No guarantees; honest about No Further Stay
// and onshore limits; no unverified figures stated as fact.

const visitor600 = {
  groupSlug: "visitor-working-holiday",
  slug: "visitor-600",
  title: "Visitor Visa (Subclass 600)",
  eyebrow: "Visitor & Working Holiday",
  intro:
    "The Subclass 600 covers short stays in Australia for tourism, visiting family, or business meetings. It has several streams to suit the purpose of your visit. It is purely temporary, and a few conditions, such as No Further Stay, can shape what you are allowed to do once you arrive.",

  chips: [
    { label: "Visa type", value: "Temporary, short stay" },
    { label: "Streams", value: "Tourist, Business, Sponsored Family" },
    { label: "Purpose", value: "Tourism, family, business visits" },
    { label: "PR pathway", value: "None" },
  ],

  whoFor: [
    "Tourists and people visiting family or friends in Australia.",
    "Business visitors attending meetings, conferences, or negotiations.",
    "People who need a clear, correctly prepared short-stay application.",
  ],

  essentials: [
    {
      title: "A genuine, temporary visit",
      detail:
        "You must show you intend a genuine visit and will leave at the end of your stay.",
    },
    {
      title: "The right stream",
      detail:
        "Tourist, Business Visitor, and Sponsored Family streams each have their own rules. A registered migration agent confirms the correct one for you.",
    },
    {
      title: "Funds and ties",
      detail:
        "You should show enough funds for your stay and genuine reasons to return home.",
    },
    {
      title: "Condition 8503, No Further Stay",
      detail:
        "Visitor visas often carry the No Further Stay condition, which prevents you applying for most other visas while in Australia. Waivers are rare.",
    },
    {
      title: "Limited onshore options",
      detail:
        "Recent rules generally stop visitor-visa holders applying for a student visa while in Australia. If you want to study, expect to apply offshore.",
    },
    {
      title: "Health and character",
      detail:
        "Standard health and character requirements apply.",
    },
  ],

  process: [
    {
      title: "Confirm the right stream",
      detail:
        "A registered migration agent matches your purpose of travel to the correct visitor stream.",
    },
    {
      title: "Organise your documents",
      detail:
        "We gather and organise your funds, ties, and travel history so the file is genuine and well-supported.",
    },
    {
      title: "Prepare the evidence",
      detail:
        "We help you assemble the supporting documents that address the genuine-visitor test.",
    },
    {
      title: "Lodge the application",
      detail:
        "We build a complete, submission-ready file, and a registered migration agent lodges it and manages correspondence with the Department.",
    },
    {
      title: "Understand your conditions",
      detail:
        "A registered migration agent explains any conditions, such as No Further Stay, so you know exactly what you can and cannot do onshore.",
    },
  ],

  faqs: [
    {
      q: "Can I switch to another visa while I am here on a visitor visa?",
      a: "Often not. Visitor visas commonly carry the No Further Stay condition, which blocks most onshore applications, and recent rules generally stop visitor holders applying for a student visa in Australia. A registered migration agent sets out your options upfront.",
    },
    {
      q: "How long can I stay?",
      a: "It depends on the stream and what the Department grants, typically a short period per visit. We organise your documents so the request matches a genuine purpose, and a registered migration agent lodges it.",
    },
    {
      q: "Can a visitor visa lead to permanent residence?",
      a: "No. The visitor visa is purely temporary with no PR pathway. If your goal is to live in Australia, we match you with a registered migration agent who can talk through the visas that actually lead there.",
    },
    {
      q: "What does it cost?",
      a: "There is a government Visa Application Charge that differs by stream and whether you apply onshore or offshore. The amounts are set by the government and change, so a registered migration agent confirms the current figure for your case.",
    },
  ],

  related: ["sponsored-family-visitor", "working-holiday", "student-500"],

  lastVerified: "13 July 2026",
};

export default visitor600;
